import { AppBar } from '@mui/material';
import { PoppIcon } from 'common/icons/PoppIcon';
import { RouterLink } from 'common/ui/RouterLink';
import { Paths } from 'services/navigation/paths';

export const PublicNavBar: React.FC = () => {
  return (
    <AppBar position="sticky" component="nav" elevation={0}>
      <RouterLink to={Paths.HOME}>
        <PoppIcon />
      </RouterLink>
    </AppBar>
  );
};

export const withPublicNavbar = (element: React.ReactElement) => {
  return (
    <>
      <PublicNavBar />
      {element}
    </>
  );
};
